// extracted by mini-css-extract-plugin
export default {"block":"style-module--block--ae971","blueLine":"style-module--blue-line--fd920"};